import { GlobalAxios } from "../axios/axios-config";

const ENCOUNTER_DATA_Z_ROUTE =
  process.env.REACT_APP_EXTERNAL + "/api/v1/EncounterDataZ";

export const restartServiceReceivedRetries = ({
  identifier,
  identifierList,
}: {
  identifier?: number;
  identifierList?: number[];
}) => {
  return GlobalAxios.put(ENCOUNTER_DATA_Z_ROUTE, {
    identifier,
    identifierList,
  });
};
